import { moduleProviderFactory } from "mrb/core";
import {
    StoriesRouteStore,
    PodcastsRouteStore,
    ShiurimRouteStore,
    StationsRouteStore,
} from "application/categories/stores";
import { StoriesPage, PodcastsPage, ShiurimPage, StationsPage } from "application/categories/pages";

(function () {
    moduleProviderFactory.module("application").register({
        name: "application.categories",
        routes: [
            {
                name: "master.application.categories.stories",
                pattern: "/categories/stories",
                authorization: ["$premium-only$"],
                component: StoriesPage,
                store: StoriesRouteStore,
                data: {
                    title: "APPLICATION.HOME.LIST.TITLE",
                },
            },
            {
                name: "master.application.categories.podcasts",
                pattern: "/categories/podcasts",
                authorization: ["$premium-only$not-mobile-restricted$"],
                component: PodcastsPage,
                store: PodcastsRouteStore,
                data: {
                    title: "APPLICATION.HOME.LIST.TITLE",
                },
            },
            {
                name: "master.application.categories.shiurim",
                pattern: "/categories/shiurim",
                authorization: ["$premium-only$"],
                component: ShiurimPage,
                store: ShiurimRouteStore,
                data: {
                    title: "APPLICATION.HOME.LIST.TITLE",
                },
            },
            {
                name: "master.application.categories.stations",
                pattern: "/categories/stations",
                authorization: ["$premium-only$not-mobile-restricted$"],
                component: StationsPage,
                store: StationsRouteStore,
                data: {
                    title: "APPLICATION.HOME.LIST.TITLE",
                },
            },
        ],
        menu: [
            {
                title: "APPLICATION.MENU.STORIES",
                order: 4,
                icon: "stories",
                route: "master.application.categories.stories",
                authorization: ["$premium-only$"],
            },
            {
                title: "APPLICATION.MENU.STATIONS",
                order: 5,
                icon: "stations",
                route: "master.application.categories.stations",
                authorization: ["$premium-only$not-mobile-restricted$"],
            },
            {
                title: "APPLICATION.MENU.PODCASTS",
                order: 6,
                icon: "podcasts",
                route: "master.application.categories.podcasts",
                authorization: ["$premium-only$not-mobile-restricted$"],
            },
            {
                title: "APPLICATION.MENU.SHIURIM",
                order: 7,
                icon: "podcasts",
                route: "master.application.categories.shiurim",
                authorization: ["$premium-only$"],
            },
        ],
    });
})();
